import { combineReducers } from 'redux';
// Import reducers
import table from './articles_availability_table_reducer';
import form from './articles_availability_form_reducer';

export default combineReducers({
	table,
	form
});
